import React from 'react';
import classNames from 'classnames';

import './Burger.component.scss';

type ButtonProps = React.HTMLAttributes<HTMLButtonElement> & {
  open: boolean;
};

const Burger: React.FC<ButtonProps> = ({ className, open, ...props }) => (
  <button
    className={classNames('burger', { 'burger--open': open }, className)}
    {...props}
  >
    <span />
    <span />
    <span />
  </button>
);

export default Burger;
